import React from "react";
import Check from "../../../assets/svgs/Check";
import EditBtn from "../../../assets/svgs/EditBtn";
import Remove from "../../../assets/svgs/Remove";

function Tr({ text, date, time }) {
  return (
    <tr>
      <td className="border-gray-400 px-3 py-6  whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {text}
      </td>
      <td className="border-gray-400 px-3 py-6  whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {date}
      </td>
      <td className="border-gray-400 px-3 py-6 whitespace-nowrap text-xs font-medium text-gray-900 border-r">
        {time}
      </td>
      <td className="border-gray-400 px-3 py-6 min-w-[50px] overflow-x-auto whitespace-nowrap text-xs font-medium text-gray-900">
        <div className="notificationShape flex w-full justify-evenly">
          <button className="m-0.5">
            <span className="flex rounded-full justify-center items-center w-6 h-6 p-1.5 -mb-1 bg-gray-50 shadow-xl text-black ">
              <Remove />
            </span>
          </button>
          <button className="m-0.5">
            <span className="flex rounded-full justify-center items-center w-6 h-6 p-1.5 -mb-1 bg-pink-500 shadow-xl text-white ">
              <Check />
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
}

const Table = () => {
  return (
    <div className="flex flex-col">
      <div className="w-full md:w-[700px] lg:w-[800px] bg-gray-20 bg-transparent mx-auto ">
        <div className="flex justify-end bg-transparent -mb-5">
          <button>
            <EditBtn />
          </button>
        </div>
        <div className="overflow-x-auto rounded-xl shadow-2xl">
          <table className="min-w-full rounded-xl shadow-2xl text-center bg-gray-100">
            <tbody className="shadow-2xl border rounded">
              <Tr
                text="Dennis Jurk joined as a employee"
                date="Wednesday, 21 October 2022"
                time="Time: 09:43 am"
              />
              <Tr
                text="Dennis Jurk joined as a employee"
                date="Wednesday, 21 October 2022"
                time="Time: 09:43 am"
              />
              <Tr
                text="Dennis Jurk joined as a employee"
                date="Wednesday, 21 October 2022"
                time="Time: 09:43 am"
              />
              <Tr
                text="Dennis Jurk joined as a employee"
                date="Wednesday, 21 October 2022"
                time="Time: 09:43 am"
              />
              <Tr
                text="Dennis Jurk joined as a employee"
                date="Wednesday, 21 October 2022"
                time="Time: 09:43 am"
              />
              <Tr
                text="Dennis Jurk joined as a employee"
                date="Wednesday, 21 October 2022"
                time="Time: 09:43 am"
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;
